import React from "react";
import propTypes from "prop-types";

import {
    Input,
    ComboBox,
    Label,
    Fieldset,
    Legend,
    Textarea,
    Header
} from "../../Components/SmartForm";

const BuyingInterest = ({
    className,
    showCategoryInput,
    categories,
    ...props
}) => {

    return (
        <div className="buying-interest" {...props}>
            <p className="informational-panel">
                {`LabX can help connect you with the right company,
                vendor, or service provider. Need a product but can't find it?
                Looking for equipment but not exactly sure where to start? Have
                a unique "wanted" request? Simply fill out the form below and leave
                it to us. We'll distribute your request to our network of qualified
                sellers who will reach out to you to address your needs.`}
            </p>
            <div className={`card ${className}`}>
                <div className="card-header">
                    <Header text="Buying Interest" />
                </div>
                <div className="card-body">
                    <Fieldset name="selection">
                        <Fieldset inline
                            name="purchase-timeline"
                            className="form-group row"
                            role="radiogroup"
                            required
                        >
                            <Legend
                                className="col-form-label col-md-2 pt-0"
                                required
                            >
                                Purchase Timeline
                            </Legend>
                            <div className="col-md-10 d-flex flex-column d-md-block">
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="purchase-timeline"
                                        value="0-3"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="purchase-timeline"
                                        option="0-3"
                                        className="form-check-label"
                                    >
                                        0 - 3 months
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="purchase-timeline"
                                        value="3-6"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="purchase-timeline"
                                        option="3-6"
                                        className="form-check-label"
                                    >
                                        3 - 6 months
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="purchase-timeline"
                                        value="6-12"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="purchase-timeline"
                                        option="6-12"
                                        className="form-check-label"
                                    >
                                        6 - 12 months
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="purchase-timeline"
                                        value="future"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="purchase-timeline"
                                        option="future"
                                        className="form-check-label"
                                    >
                                        Future purchase
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="purchase-timeline"
                                        value="information"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="purchase-timeline"
                                        option="information"
                                        className="form-check-label"
                                    >
                                        Information only
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="purchase-timeline"
                                        value="urgent"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="purchase-timeline"
                                        option="urgent"
                                        className="form-check-label"
                                    >
                                        Urgent! Contact ASAP
                                    </Label>
                                </div>
                            </div>
                        </Fieldset>
                        <Fieldset inline
                            name="condition-age"
                            label="Condition/Age"
                            className="form-group row"
                            role="radiogroup"
                            required
                        >
                            <Legend
                                className="col-form-label col-md-2 pt-0"
                                required
                            >
                                Condition/Age
                            </Legend>
                            <div className="col-md-10 d-flex flex-column d-md-block">
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="condition-age"
                                        value="new"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="condition-age"
                                        option="new"
                                        className="form-check-label"
                                    >
                                        New Product
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="condition-age"
                                        value="used"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="condition-age"
                                        option="used"
                                        className="form-check-label"
                                    >
                                        Used/Refurbished Product
                                    </Label>
                                </div>
                            </div>
                        </Fieldset>
                        <Fieldset inline
                            name="equipment-needed"
                            className="form-group row"
                            role="radiogroup"
                            required
                        >
                            <Legend
                                className="col-form-label col-md-2 pt-0"
                                required
                            >
                                Equipment Needed
                            </Legend>
                            <div className="col-md-10 d-flex flex-column d-md-block">
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="equipment-needed"
                                        value="system"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="equipment-needed"
                                        option="system"
                                        className="form-check-label"
                                    >
                                        Complete System
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="equipment-needed"
                                        value="accessories"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="equipment-needed"
                                        option="accessories"
                                        className="form-check-label"
                                    >
                                        Accessories/Add-Ons
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="equipment-needed"
                                        value="parts"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="equipment-needed"
                                        option="parts"
                                        className="form-check-label"
                                    >
                                        Parts
                                    </Label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Input
                                        type="radio"
                                        name="equipment-needed"
                                        value="service"
                                        className="form-check-input"
                                    />
                                    <Label
                                        input="equipment-needed"
                                        option="service"
                                        className="form-check-label"
                                    >
                                        Service
                                    </Label>
                                </div>
                            </div>
                        </Fieldset>
                    </Fieldset>
                    {showCategoryInput ? (
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <Label
                                    input="category"
                                    required
                                >
                                    Category
                                </Label>
                                <ComboBox
                                    name="category"
                                    options={categories}
                                    fallbackProps={{
                                        className: "form-control"
                                    }}
                                    labelKey="name"
                                    valueKey="id"
                                    required
                                />
                            </div>
                        </div>
                    ) : (
                        <Input type="hidden" name="category" />
                    )}
                    <div className="form-row">
                        <div className="form-group col-6">
                            <Label input="manufacturer">Manufacturer</Label>
                            <Input
                                name="manufacturer"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-6">
                            <Label input="model">Model</Label>
                            <Input
                                name="model"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <Label
                            input="message"
                            required
                        >
                            Message
                        </Label>
                        <Textarea
                            name="message"
                            className="form-control"
                            rows={5}
                            required
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

BuyingInterest.propTypes = {
    className: propTypes.string,
    showCategoryInput: propTypes.bool,
    categories: propTypes.array,
};

export default BuyingInterest;
